
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { Navigation } from "./Navigation";
import { AuthSection } from "./AuthSection";

interface MobileMenuProps {
  user: any;
  userRole: string | null;
  getDashboardLink: () => string;
  handleLogout: () => Promise<void>;
}

export const MobileMenu = ({ user, userRole, getDashboardLink, handleLogout }: MobileMenuProps) => {
  return (
    <div className="md:hidden">
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon">
            <Menu className="h-5 w-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="right" className="w-[80%] sm:w-[385px]">
          <div className="flex flex-col space-y-4 py-4">
            <Navigation user={user} userRole={userRole} />
            <div className="pt-4 border-t">
              <AuthSection 
                user={user}
                getDashboardLink={getDashboardLink}
                handleLogout={handleLogout}
              />
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};
